import { useLocalStorage } from 'usehooks-ts';

import {
  englishLocaleKey,
  storageKeys,
  supportedLocales,
} from '@app/constants';

const getBrowserLocale = (): string => {
  const browserLocale = navigator.languages
    ? navigator.languages[0]
    : navigator.language;

  return (
    supportedLocales.find(({ id }) => browserLocale.startsWith(id))?.id ||
    englishLocaleKey
  );
};

export const useAppLocale = () => {
  const browserLocale = getBrowserLocale();

  const [locale, setLocale] = useLocalStorage<string>(
    storageKeys.locale,
    browserLocale
  );

  return { locale, setLocale };
};
